<template>
  <ValidationObserver ref="selectCandidate">
    <div>
      <h2 class="mt-5">Who do you want to send a self-schedule invite to?</h2>
      <WorkersSelectionWithBottomItems
        class="mt-3"
        :showValidationErrors="showValidationErrors"
        :workers="formattedWorkers"
        :isLoading="isLoading"
        @change="emitChange"
        isCandidates
      />
    </div>
  </ValidationObserver>
</template>

<script>
import WorkersSelectionWithBottomItems from "@/components/bookings/WorkersSelectionWithBottomItems";
import { createNamespacedHelpers } from "vuex";
import { ValidationObserver } from "vee-validate";
import {
  BOOKINGS_NAMESPACE,
  FETCH_CURRENT_BOOKING_CANDIDATES
} from "@/store/modules/bookings/actions";
import {
  GET_CURRENT_BOOKING_CANDIDATES,
  IS_LOADING_BOOKING_CANDIDATES
} from "@/store/modules/bookings/getters";
import { getCandidateName } from "@/utils/users";
import { map } from "lodash";

const {
  mapActions: mapBookingActions,
  mapGetters: mapBookingGetters
} = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  components: {
    WorkersSelectionWithBottomItems,
    ValidationObserver
  },
  props: {
    interviewFormatId: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchCurrentBookingApplications({
      bookingId: this.currentBookingId,
      params: this.requestParams
    });
  },
  data() {
    return {
      candidates: [],
      showValidationErrors: false
    };
  },
  computed: {
    ...mapBookingGetters({
      allApplications: GET_CURRENT_BOOKING_CANDIDATES,
      isLoading: IS_LOADING_BOOKING_CANDIDATES
    }),
    formattedWorkers() {
      return map(this.allApplications, application => ({
        ...application.user,
        fullName: getCandidateName(application)
      }));
    },
    currentBookingId() {
      return this.$route.params.id;
    },
    requestParams() {
      return {
        filter: {
          status: ["unsorted", "evaluated", "shortlisted", "offered"],
          not_invited_to_interview_format_id: this.interviewFormatId
        }
      };
    }
  },
  methods: {
    ...mapBookingActions({
      fetchCurrentBookingApplications: FETCH_CURRENT_BOOKING_CANDIDATES
    }),
    emitChange(candidates) {
      this.$emit("onChange", {
        candidates
      });
    },
    async validateForm() {
      this.showValidationErrors = true;
      return this.$refs.selectCandidate.validate();
    }
  },
  watch: {
    interviewFormatId() {
      this.fetchCurrentBookingApplications({
        bookingId: this.currentBookingId,
        params: this.requestParams
      });
    }
  }
};
</script>

<style lang="scss"></style>
